export const productGridClassName = "grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-4";
